<template>
  <div class="student-new">
    <div class="hd ly-card">
      <div class="fl">
        <el-button class="fl" type="primary">导出</el-button>
        <el-popover placement="bottom" width="400" trigger="click" class="m-l-10 m-r-10" :visible-arrow="false">
          <div class="high-search">
            <ly-form :formConfig="searchFormConfig" :formKeys="searchFormKeys" ref="lySearchForm"></ly-form>
            <el-button type="primary" size="medium" @click="search">查询</el-button>
          </div>
          <el-button slot="reference" type="primary" @click="search">
            高级查询
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </el-popover>
      </div>
      <div class="fr">
        <el-input v-model.trim="searchFormData.name" placeholder="学员姓名/学籍号/家长电话/身份证号"></el-input>
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :tableConfig="tableConfig"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:a="row">
        <el-button type="text" size="small" @click="() => openInf(row)">{{ row.a }}</el-button>
      </template>
    </ly-table>
    <el-dialog title="学员详情" :visible.sync="dialogVisible" width="98%">
      <el-tabs value="base">
        <el-tab-pane label="基础信息" name="base">
          <ul class="base-inf">
            <li>
              <span>姓名</span>
              <i>xx</i>
            </li>
            <li>
              <span>出生日期</span>
              <i>xx</i>
            </li>
            <li>
              <span>性别</span>
              <i>xx</i>
            </li>
            <li>
              <span>身份证号</span>
              <i>xx</i>
            </li>
            <li>
              <span>就读学校</span>
              <i>xx</i>
            </li>
            <li>
              <span>就读年级</span>
              <i>xx</i>
            </li>
            <li>
              <span>学籍号</span>
              <i>xx</i>
            </li>
            <li>
              <span>监护人姓名</span>
              <i>xx</i>
            </li>
            <li>
              <span>监护人手机号</span>
              <i>xx</i>
            </li>
            <li>
              <span>备注</span>
              <i>xx</i>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="报名信息" name="sign">
          <ly-table
            :getTableData="getTableData"
            :tableHeader="tableHeaderSign"
            :tableConfig="tableConfig"
            :searchFormData="searchFormData"
            :paginConfig="{ isHide: true }"
            ref="lyTable"
          ></ly-table>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Input, Popover, Tabs, TabPane } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { studentTable, studentSignTable } from '@/utils/tableHeader';
import { specializedSearchForm } from '@/utils/formConfigCommon';

export default {
  name: 'StudentNew',
  components: {
    LyTable,
    LyForm,
    ElPopover: Popover,
    ElInput: Input,
    ElDialog: Dialog,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data() {
    return {
      searchFormData: {
        name: '',
        org_id: '',
        specialized_subject_id: ''
      },
      tableHeader: Object.freeze(studentTable),
      tableHeaderSign: Object.freeze(studentSignTable),
      getTableData: () => {},
      tableConfig: {
        data: [{ a: 'name' }]
      },
      searchFormConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormKeys: specializedSearchForm,
      dialogVisible: false
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    async search() {
      const { data } = await this.$refs.lySearchForm.getFormData();
      const temp = {
        org_id: data.org_id,
        specialized_subject_id: data.specialized_subject_id_child || data.specialized_subject_id_parent
      };

      this.searchFormData = {
        ...this.searchFormData,
        ...temp
      };
      this.$refs.lyTable.setData();
    },
    openInf() {
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less">
.student-new {
  .hd {
    overflow: hidden;
    .el-input {
      width: 260px;
      margin-right: 20px;
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .base-inf {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
}
</style>
